module.exports = __webpack_public_path__ + "media/components/MenuMobile/closed-420ca78d2de8c23e293d7250ba231d2269f27a69e972cdc6ca0c42c39931d1b1.svg";